import React, { useState, useEffect, useRef } from 'react';

import { SearchIcon } from '../Icons';

import './SearchBar.scss';

export interface ISearchBarProps {
  searchTerm: string;
  onChange: (term: string) => void;
}

const SearchBar = ({ searchTerm, onChange }: ISearchBarProps) => {
  const [currentTerm, setCurrentTerm] = useState<string>(searchTerm);
  const searchBarRef = useRef<HTMLInputElement | null>(null);
  const timerId = useRef<any>();

  useEffect(() => {
    searchBarRef?.current?.focus();
  }, [searchBarRef]);

  useEffect(() => {
    setCurrentTerm(searchTerm);
  }, [searchTerm, searchBarRef]);

  const onChangeDebounced = (event: any) => {
    const value = event.currentTarget.value;
    clearTimeout(timerId.current);
    timerId.current = setTimeout(() => {
      if (value.length >= 2 || !value) {
        onChange(value);
      }
    }, 350);

    setCurrentTerm(value);
  };

  return (
    <div className="search-bar">
      <SearchIcon className="search-bar__icon" />
      <input
        aria-controls="search-listbox"
        placeholder="Search for Movies, Shows, Events, Cast Members, or Networks"
        type="text"
        className="search-bar__input"
        value={currentTerm}
        onChange={onChangeDebounced}
        ref={searchBarRef}
      />
      {searchTerm.length ? (
        <button
          aria-label="Clear Search"
          className="search-bar__clear"
          onClick={() => {
            onChange('');
            searchBarRef?.current?.focus();
          }}
        >
          Clear
        </button>
      ) : null}
    </div>
  );
};

export default SearchBar;
